/**
 * @generated SignedSource<<0d844057a5f76316f54ab76b675163ed>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type latestContentsQuery$data = {
  readonly contents: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly entityId: string;
        readonly " $fragmentSpreads": FragmentRefs<"homeLatestContentItemContent">;
      };
    }>;
  };
  readonly " $fragmentType": "latestContentsQuery";
};
export type latestContentsQuery$key = {
  readonly " $data"?: latestContentsQuery$data;
  readonly " $fragmentSpreads": FragmentRefs<"latestContentsQuery">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "latestExcludeArticleTypes"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "latestExcludeSectionIds"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "scmpPlusPaywallTypeIds"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "latestContentsQuery",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "fields": [
            {
              "kind": "Variable",
              "name": "articleTypeIds",
              "variableName": "latestExcludeArticleTypes"
            },
            {
              "kind": "Variable",
              "name": "paywallTypeIds",
              "variableName": "scmpPlusPaywallTypeIds"
            }
          ],
          "kind": "ObjectValue",
          "name": "articleExcludeInput"
        },
        {
          "kind": "Literal",
          "name": "articleFilterInput",
          "value": {
            "sponsorTypes": [
              "NONE"
            ]
          }
        },
        {
          "kind": "Literal",
          "name": "contentTypes",
          "value": [
            "ARTICLE",
            "GALLERY",
            "VIDEO"
          ]
        },
        {
          "fields": [
            {
              "kind": "Variable",
              "name": "sectionIds",
              "variableName": "latestExcludeSectionIds"
            }
          ],
          "kind": "ObjectValue",
          "name": "exclude"
        },
        {
          "kind": "Literal",
          "name": "first",
          "value": 6
        },
        {
          "kind": "Literal",
          "name": "orderBy",
          "value": {
            "direction": "DESC",
            "field": "PUBLISHED_DATE"
          }
        }
      ],
      "concreteType": "ContentConnection",
      "kind": "LinkedField",
      "name": "contents",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ContentEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "entityId",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "homeLatestContentItemContent"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "4319ef424fe92a585cef0ffb8fc64db9";

export default node;
